import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@sainsburys-tech/bolt'
import * as Styled from './M010.styles'

/**
  ** M010 is a product card that varies depending on the page it is used on:
  - CLP (Category Lister Page)
  - PLP (Product Lister Page)
  - SLP (Search Lister Page)
  ** M10 has different attributes that can be seen in the table below
 */
const M010 = ({ validProduct, ctaCopy, attributes, gridClasses }) => {
  if (!validProduct || !attributes) return null
  const {
    badge,
    freeDelivery,
    hasMultiplePrices,
    linkTagging,
    name,
    price,
    productId,
    rating,
    reviewsCount,
    specialOfferText,
    wasPrice,
    displayRating,
    displayFreeDelivery
  } = attributes
  const productLinkFormat = `/product/${productId}`
  const productLink = !linkTagging ? productLinkFormat : `${productLinkFormat}${linkTagging}`
  const m010Props = {
    wishlistCta: false,
    lazyImageLoad: true,
    cta: (
      <Button as='a' kind='secondary' href={productLink} className='btn-cta' data-test='m010-cta'>
        {ctaCopy}
      </Button>
    )
  }

  return (
    <Styled.M010ProductCard
      className={`${gridClasses || ''}`}
      name={name}
      partNumber={productId}
      productLinkOverride={productLink}
      wasPrice={wasPrice}
      badge={badge}
      freeDelivery={displayFreeDelivery && freeDelivery}
      rating={displayRating && reviewsCount !== 0 ? rating : null}
      hasMultiplePrices={hasMultiplePrices}
      specialOfferText={specialOfferText}
      reviewsCount={reviewsCount}
      price={price}
      data-test='m010'
      mobileLayout='vertical'
      {...m010Props}
    />
  )
}

M010.propTypes = {
  /** Required object with attributes for the product */
  attributes: PropTypes.shape({
    /** Optional object with badge attributes */
    badge: PropTypes.shape({
      /** Optional array with badge values */
      BADGE_VALUE: PropTypes.array,
      /** Optional array with badge product values */
      BADGE_PRODUCT: PropTypes.array,
      /** Optional array with badge deliver00y values */
      BADGE_DELIVERY: PropTypes.array
    }),
    /** Optional value for free delivery */
    freeDelivery: PropTypes.bool,
    /** Optional value indicating multiple prices */
    hasMultiplePrices: PropTypes.bool,
    /** Optional value for link tagging */
    linkTagging: PropTypes.string,
    /** Required product name */
    name: PropTypes.string.isRequired,
    /** Required product price */
    price: PropTypes.number.isRequired,
    /** Required productId */
    productId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    /** Optional product rating */
    rating: PropTypes.number,
    /** Optional number of reviews */
    reviewsCount: PropTypes.number,
    /** Optional text for special offer */
    specialOfferText: PropTypes.string,
    /** Optional previous price */
    wasPrice: PropTypes.number,
    /** Option to display the rating, only if the reviews count is at least equal to 1 */
    displayRating: PropTypes.bool,
    /** Option to display free delivery badge, only if freeDelivery is true */
    displayFreeDelivery: PropTypes.bool
  }).isRequired,
  /** Optional copy for the CTA */
  ctaCopy: PropTypes.string,
  /** Optional component type */
  type: PropTypes.string,
  /** Optional value to check if the product is valid  */
  validProduct: PropTypes.bool
}

M010.defaultProps = {
  ctaCopy: 'More details',
  type: 'M010',
  validProduct: true
}

export default M010
